module.exports = __webpack_public_path__ + "static/img/trueIcon.b49d1b41.png";